import keys from '@debbie/common/dist/cache/keys.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as collectorsAPI from '@debbie/cortex/dist/api/collectors.js';
import { collectorsEntity } from '@debbie/cortex/dist/collectors/index.js';
import q from '@debbie/cortex/dist/query.js';
import React from 'react';
import PaymentOptionsComponent from '../../PaymentOptions.js';
const PaymentOptions = (props) => {
    const { heading, collectorId, paymentOptions } = props;
    const updatePaymentOptions = useMutation((paymentOptions) => collectorsAPI.update(collectorId, {
        paymentOptions,
    }), {
        onSuccess: () => {
            q.invalidate(keys.write.modify(collectorsEntity, collectorId));
        },
        onError: (err) => {
            console.log(err);
            alert(err);
        },
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, heading),
        React.createElement(PaymentOptionsComponent, { collectorId: collectorId, options: paymentOptions, onChange: (paymentOptions) => updatePaymentOptions.mutate(paymentOptions) })));
};
export default PaymentOptions;
//# sourceMappingURL=PaymentOptions.js.map